var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenTickIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4375 0C11.582 0 8.7907 0.846745 6.41646 2.43316C4.04223 4.01957 2.19174 6.2744 1.099 8.91251C0.00625553 11.5506 -0.279655 14.4535 0.277419 17.2541C0.834493 20.0547 2.20953 22.6272 4.22865 24.6464C6.24777 26.6655 8.82029 28.0405 11.6209 28.5976C14.4215 29.1547 17.3244 28.8687 19.9625 27.776C22.6006 26.6833 24.8554 24.8328 26.4418 22.4585C28.0283 20.0843 28.875 17.293 28.875 14.4375C28.875 10.6084 27.3539 6.9362 24.6464 4.22865C21.9388 1.52109 18.2666 0 14.4375 0ZM12.375 20.2022L7.21876 15.0459L8.85844 13.4062L12.375 16.9228L20.0166 9.28125L21.6624 10.9168L12.375 20.2022Z",
    fill: "#03A753"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTickIcon);
export default __webpack_public_path__ + "static/media/GreenTickIcon.60fb4873b115b19d14468547629cc30f.svg";
export { ForwardRef as ReactComponent };